import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, User, UserProfile } from '../../types/types';
import { AppSyncUser } from '../../services/auth/types/user';

const initialState: AuthState = {
  isLoggedIn: false,
  user: null,
  userProfile: {
    avatar: '😊'
  },
  appSyncUser: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<User>) => {
      state.isLoggedIn = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.userProfile = {
        avatar: '😊'
      };
      state.appSyncUser = null;
      state.error = null;
    },
    updateUserProfile: (state, action: PayloadAction<Partial<UserProfile>>) => {
      state.userProfile = { ...state.userProfile, ...action.payload };
    },
    setAppSyncUser: (state, action: PayloadAction<AppSyncUser>) => {
      state.appSyncUser = action.payload;
      // Update userProfile with AppSync data
      const fullName = `${action.payload.firstName || ''} ${action.payload.lastName || ''}`.trim();
      state.userProfile = {
        ...state.userProfile,
        name: fullName || action.payload.email,
        email: action.payload.email,
        avatar: action.payload.avatarUrl || state.userProfile.avatar,
      };
    },
    updateAppSyncUser: (state, action: PayloadAction<Partial<AppSyncUser>>) => {
      if (state.appSyncUser) {
        const updatedUser: AppSyncUser = { ...state.appSyncUser, ...action.payload };
        state.appSyncUser = updatedUser;
        // Update userProfile accordingly
        const fullName = `${updatedUser.firstName || ''} ${updatedUser.lastName || ''}`.trim();
        state.userProfile = {
          ...state.userProfile,
          name: fullName || updatedUser.email,
          email: updatedUser.email,
          avatar: updatedUser.avatarUrl || state.userProfile.avatar,
        };
      }
    },
    clearAppSyncUser: (state) => {
      state.appSyncUser = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  updateUserProfile,
  setAppSyncUser,
  updateAppSyncUser,
  clearAppSyncUser,
  clearError,
} = authSlice.actions;

export default authSlice.reducer; 